import {
  Animatespin,
  MainHeading,
  Footer,
  Navbar,
  Experience,
} from "../../components/index";
import localimgpath from "../../js/localimgpath";

import Icons from "../../assets/icon";
import sanitizeHtml from "../../js/sanitizeHtml";
import Functions from "./index.function";
const NewsDetails = () => {
  const { isLoading, singleNews, handleSevedEvent, userId, loadingapi } =
    Functions();

  return (
    <div className="bg-primary">
      <Navbar />
      <div className="lg:px-5 xl:px-10  sm:px-5 xs:px-3 m-auto xs:py-5">
        {isLoading === true ? (
          <Animatespin />
        ) : (
          <>
            <MainHeading
              title={singleNews?.news_title}
              // dis={singleNews?.short_description}
              dis={''}
              layout={"h-18 sm:h-20 lg:h-36"}
              navigate={"/news"}
            />
            <div className="w-full xs:h-[150px] sm:h-[17.5rem] lg:h-[24rem] xl:h-[20rem] 2xl:h-[20rem] xs:mt-2" style={{marginTop: 1 + 'em'}}>
              <img
                className="w-full h-full xs:rounded-3xl sm:rounded-[35px] lg:rounded-[70px] object-cover"
                src={`${localimgpath?.newsBanner}/${singleNews?.banner}`}
                alt={singleNews?.news_title}
              />
            </div>
            <div className="xs:pt-5 xs:pb-2 sm:pt-6 sm:pb-2 lg:pt-0 lg:pb-0">
              <div className="flex justify-between items-center">
                <h2 className="text-secondary font-unboundedMedium lg:text-3xl xs:pb-2 sm:pb-2 lg:mt-14 lg:pb-5">
                  News Info
                </h2>
              </div>  
              <div
                className="prose text-secondary font-onestLight xs:mb-1 xs:text-xs sm:text-xs xl:mb-4 lg:mb-2 sm:mb-2 xl:text-base lg:text-sm"
                dangerouslySetInnerHTML={{
                  __html: sanitizeHtml(singleNews?.short_description),
                }}
              />
              <div className="flex justify-between items-center">
                <h2 className="text-secondary font-unboundedMedium lg:text-3xl xs:pb-2 sm:pb-2 lg:mt-14 lg:pb-5">
                  News Detail
                </h2>
                <div
                  className={`group xs:w-10 xs:h-10 sm:w-10 sm:h-10 lg:w-12 lg:h-12 flex justify-center items-center rounded-full transition-all duration-300
                                hover:scale-110 cursor-pointer bg-[#1A1A1A] hover:bg-[#333333]`}
                  onClick={() => {
                    handleSevedEvent(userId, singleNews?.id);
                  }}
                >
                  {loadingapi ? (
                    <div className="flex justify-center items-center">
                      <div className="animate-spin rounded-full border-t-2 border-b-2 group-hover:border-primary border-secondary lg:w-6 lg:h-6 sm:w-4 sm:h-4 xs:w-3 xs:h-3"></div>
                    </div>
                  ) : (
                    <img
                      className={`xs:w-4 sm:w-4 lg:w-5 transition-all duration-300 group-hover:scale-110
                                                }`}
                      src={
                        singleNews?.is_favourite
                          ? Icons.dasSavedIcon
                          : Icons.dasSaveIcon
                      }
                      alt={
                        singleNews?.is_favourite
                          ? Icons.dasSavedIcon
                          : Icons.dasSaveIcon
                      }
                    />
                  )}
                </div>
              </div>
              <div
                className="prose text-secondary font-onestLight xs:mb-1 xs:text-xs sm:text-xs xl:mb-4 lg:mb-2 sm:mb-2 xl:text-base lg:text-sm"
                dangerouslySetInnerHTML={{
                  __html: sanitizeHtml(singleNews?.description),
                }}
              />
            </div>
          </>
        )}
        <div className="">
          <Experience />
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default NewsDetails;
